import type { Localizations, LocalizationsProvider } from "~/service/l10n";
import { theme_ns } from "./theme";

export const translations = {
  'en-US': {
    'common.today': 'Today',
    'common.learn-more': 'Learn more',
    'common.lunch-list': 'Lunch List',
    'common.floor': 'Floor',
    'common.closed': 'Closed',
    
    // Weekdays should be common
    'common.weekdays.monday': 'Monday',
    'common.weekdays.tuesday': 'Tuesday',
    'common.weekdays.wednesday': 'Wednesday',
    'common.weekdays.thursday': 'Thursday',
    'common.weekdays.friday': 'Friday',
    'common.weekdays.saturday': 'Saturday',
    'common.weekdays.sunday': 'Sunday',

    'opening-hours-swiper.todays-hours': "Today's Hours",
    'opening-hours-swiper.tomorrows-hours': "Tomorrow's Hours",
    'opening-hours-swiper.day-after-hours': "Day After Tomorrow's Hours",
    'opening-hours-swiper.store-hours-vary': 'Individual Store Hours May Vary',
    
    'footer.connect': 'connect',
    'footer.all-hours': 'see all hours',
    'footer.visit-us': 'visit us',
    'footer.privacy-center': 'Privacy Center',
    
    'search.search': 'Search',
    'search.no-results': 'Your search did not match any results',
    'search.results': 'Search Results',
    'search.stores': 'Stores',
    'search.offers': 'Offers',
    'search.events': 'Events',
    'search.opening-hours-not-available': 'Opening hours not available',
    'search.view-store': 'View Store',
    'search.call-store': 'Call us',
    'search.floor-1': '1st Floor',
    'search.floor-2': '2nd Floor',
    'search.floor-3': '3rd Floor',
    'search.floor-4': '4th Floor',
    'search.floor-5': '5th Floor',
    'search.store-section-header': 'Stores',
    'search.offer-section-header': 'Offers',
    'search.event-section-header': 'Events',
    'search.results-for': 'Results for',
    'search.see-all': 'See all',
    
    'stores.all-categories': 'All Categories',
    'stores.no-results': 'No stores found',
    'stores.stores': 'Stores',
    'stores.see-more': 'See more',
    'stores.see-less': 'See less',
    
    'store.see-in-map': 'See in Map',
    'store.opening-hours': 'Opening Hours',
    'store.exceptions': 'Exceptions',
    'store.offers': 'Offers',
    'store.all-offers': 'See All',
    'store.related': 'Related Stores',
    'store.all-related': 'See All Related Stores',

    'days.0': 'Sunday',
    'days.1': 'Monday',
    'days.2': 'Tuesday',
    'days.3': 'Wednesday',
    'days.4': 'Thursday',
    'days.5': 'Friday',
    'days.6': 'Saturday',

    'lunch-list.modal-title': 'Lunch List',
    'about-us.opening-hours-title': 'Opening Hours',
    'about-us.opening-hours-note': 'For specific hours of operation at your favorite shopping and dining destinations:',
    'about-us.opening-hours-goto-stores': 'Go to Stores',
    'about-us.opening-hours-center-doors-open': 'Center doors open',
    'about-us.parking-title': 'Parking',
    'about-us.sustainability-title': 'Sustainability',
    'about-us.contact-us-title': 'Contact Us',

    // For campaign pages:
    'offers.allDays': 'All days',
    'offers.allCategories': 'All categories',
    'offers.allOffers': 'All offers',
    'offers.showWishList': 'Show wish list',
    'offers.closeOffer': 'Close',
    'offers.seeWholeOffer': 'See whole offer',
    'offers.noOffers': 'Unfortunately no offers are currently available',
    'offers.noContent':'No content currently available',
    'offers.searchBox':'Search',
    'offers.clearSelection': 'Clear selection',
    'offers.openInfo':'Open offer description',
    'offers.daysLowestPrice': '30 day lowest price',
    'offers.store': 'Store',
    'offers.offer': 'Offer',
    'offers.valid': 'Valid',
    'offers.send-email': 'Send email',


    'news-and-events.news-and-events': 'News and Events ',
    
    'offer-lists.search-filter-store-name': 'Store',
    'offer-lists.search-filter-category': 'Category',
    'offer-lists.clear-search-filter': 'Clear Selection',
    'offer-lists.valid-from': 'Valid From',

    'news-and-events-lists.search-filter-keyword': 'Keyword',

    'news-and-events-single-article.read.more': 'Read More News & Events',

    'news-letter-lift.email-address': 'enter your email address here',
    'news-letter-lift.subscribe': 'Subscribe',
    'news-letter-lift.confirmation-message': 'You have successfully subscribed to the newsletter!',
  },
  'fi-FI': {
    'common.today': 'Tänään',
    'common.learn-more': 'Lue lisää',
    'common.lunch-list': 'Lounaslista',
    'common.floor': 'Kerros',
    'common.closed': 'Suljettu',
    
    // Weekdays should be common
    'common.weekdays.monday': 'Maanantai',
    'common.weekdays.tuesday': 'Tiistai',
    'common.weekdays.wednesday': 'Keskiviikko',
    'common.weekdays.thursday': 'Torstai',
    'common.weekdays.friday': 'Perjantai',
    'common.weekdays.saturday': 'Lauantai',
    'common.weekdays.sunday': 'Sunnuntai',

    'opening-hours-swiper.todays-hours': 'Aukioloajat tänään',
    'opening-hours-swiper.tomorrows-hours': 'Aukioloajat huomenna',
    'opening-hours-swiper.day-after-hours': 'Aukioloajat ylihuomisen jälkeen',
    'opening-hours-swiper.store-hours-vary': 'Yksittäisien liikkeiden aukioloajat voivat vaihdella',
    
    'footer.connect': 'yhdistä',
    'footer.all-hours': 'katso aukioloajat',
    'footer.visit-us': 'vieraile meillä',
    'footer.privacy-center': 'Tietosuojakäytäntö',
    
    'search.search': 'Haku',
    'search.no-results': 'Hakusi ei tuottanut yhtään tulosta',
    'search.results': 'Hakutulokset',
    'search.stores': 'Kaupat',
    'search.offers': 'Tarjoukset',
    'search.events': 'Tapahtumat',
    'search.opening-hours-not-available': 'Aukioloajat ei ole saatavilla',
    'search.view-store': 'Katso kauppa',
    'search.call-store': 'Soita',
    'search.floor-1': '1. kerros',
    'search.floor-2': '2. kerros',
    'search.floor-3': '3. kerros',
    'search.floor-4': '4. kerros',
    'search.floor-5': '5. kerros',
    'search.store-section-header': 'Kaupat',
    'search.offer-section-header': 'Tarjoukset',
    'search.event-section-header': 'Tapahtumat',
    'search.results-for': 'Tulokset hakusanalle',
    'search.see-all': 'Katso kaikki',
    
    'stores.all-categories': 'Kaikki kategoriat',
    'stores.no-results': 'Ei kauppoja löytynyt',
    'stores.stores': 'Liikkeet',
    'stores.see-more': 'Näytä lisää',
    'stores.see-less': 'Näytä vähemmän',
    
    'store.see-in-map': 'Katso kartalla',
    'store.opening-hours': 'Aukioloajat',
    'store.exceptions': 'Poikkeamat',
    'store.offers': 'Tarjoukset',
    'store.all-offers': 'Kaikki tarjoukset',
    'store.related': 'Liittyvät kaupat',
    'store.all-related': 'Näytä kaikki liittyvät kaupat',

    'days.0': 'Sunnuntai',
    'days.1': 'Maanantai',
    'days.2': 'Tiistai',
    'days.3': 'Keskiviikko',
    'days.4': 'Torstai',
    'days.5': 'Perjantai',
    'days.6': 'Lauantai',
    
    'about-us.opening-hours-title': 'Aukioloajat',
    'about-us.opening-hours-note': 'Tietyt aukioloajat suosikkiostos- ja ruokailukohteissasi:',
    'about-us.opening-hours-goto-stores': 'Siirry kauppoihin',
    'about-us.opening-hours-center-doors-open': 'Kaupanovi käyttöönotto',
    'about-us.parking-title': 'Parkeeraukset',
    'about-us.sustainability-title': 'Kestävä kehitys',
    'about-us.contact-us-title': 'Ota yhteyttä',

    // For campaign pages:
    'offers.allDays': 'Kaikki päivät',
    'offers.allCategories': 'Kaikki toimialat',
    'offers.allOffers': 'Kaikki tarjoukset',
    'offers.showWishList': 'Näytä muistilista',
    'offers.closeOffer': 'Sulje',
    'offers.seeWholeOffer': 'Avaa koko tarjous',
    'offers.noOffers': 'Etuja ei valitettavasti tällä hetkellä ole saatavilla',
    'offers.noContent': 'Ei näytettävää sisältöä juuri nyt',
    'offers.searchBox': 'Haku',
    'offers.clearSelection': 'Tyhjennä valinnat',
    'offers.openInfo':'Avaa lisätiedot',
    'offers.daysLowestPrice': '30 pv alin hinta',
    'offers.store': 'Liike',
    'offers.offer': 'Tarjous',
    'offers.valid': 'Voimassa',
    'offers.send-email': 'Lähetä sähköposti',

    'news-and-events.news-and-events': 'Uutisia ja Tapahtumia',
    'lunch-list.modal-title': 'Lunch List',
    
    'offer-lists.search-filter-store-name': 'Liikkeet',
    'offer-lists.search-filter-category': 'Kategoria',
    'offer-lists.clear-search-filter': 'Tyhjennä valinta',
    'offer-lists.valid-from': 'Voimassa',

    'news-and-events-lists.search-filter-keyword': 'Avainsana',

    'news-and-events-single-article.read.more': 'Lue Lisää Uutisia ja Tapahtumia',

    'news-letter-lift.email-address': 'kirjoita sähköpostiosoitteesi tähän',
    'news-letter-lift.subscribe': 'liity tilaajaksi',
    'news-letter-lift.confirmation-message': 'Olet onnistuneesti tilannut uutiskirjeen!',
  }
} as Localizations;

const provider: LocalizationsProvider = {
  namespace: theme_ns,
  localizations: translations,
};

export default provider;
